import React, { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import api from '../../services/api';

const ProtectedRoute = ({ children }) => {
  const { user, loading: authLoading } = useAuth();
  const location = useLocation();
  const [orgLoading, setOrgLoading] = useState(true);
  const [hasOrganization, setHasOrganization] = useState(false);

  useEffect(() => {
    const checkOrganization = async () => {
      if (!user) return;

      try {
        const response = await api.get('/organizations');
        const hasOrg = response.data.organizations && response.data.organizations.length > 0;
        setHasOrganization(hasOrg);
      } catch (error) {
        console.error('Failed to check organization:', error);
        setHasOrganization(false);
      } finally {
        setOrgLoading(false);
      }
    };

    if (user && !authLoading) {
      checkOrganization();
    }
  }, [user, authLoading]);

  if (authLoading || (user && orgLoading)) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <Loader2 className="h-8 w-8 animate-spin" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If user exists but has no organization, redirect to setup
  if (user && !hasOrganization) {
    return <Navigate to="/organization-setup" replace />;
  }

  return children;
};

export default ProtectedRoute;